<template>
  <div class="adminPage">
    <modal
      name="ProgramModal"
      width="80%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
    >
      <div class="tabcontent">
        <ValidationObserver ref="obsFieldsUpdate">
          <FormupdatePeriods
            :FieldsForm="formUpdate"
            :ModelForm="formUpdModel"
            :method="executeProcess"
            v-if="renderComponent2"
          />
        </ValidationObserver>
        <div class="modalActions">
          <button
            v-if="!isNew"
            id="updatePeriod"
            class="loginbtn primaryBtn"
            @click="updatePeriod"
          >
            Actualizar
          </button>

          <button
            v-else
            id="AddProgram"
            class="loginbtn primaryBtn"
            @click="AddProgram"
          >
            Guardar
          </button>

          <button
            id="CancelUser"
            class="loginbtn secondaryBtn"
            @click="CancelUser"
          >
            Cancelar
          </button>
        </div>
      </div>
    </modal>
    <div class="titlePage">
      Administración - Periodos Ibero
    </div>
    <va-notification color="info" v-if="addRExito" class="refNoData">
      Se creó correctamente el periodo solicitado.
    </va-notification>

    <va-notification color="info" v-if="UpdRExito" class="refNoData">
      Se actualizó correctamente el periodo solicitado.
    </va-notification>

    <va-notification color="danger" v-if="refNoUpdate" class="refNoData">
      La actualización del periodo presentó un fallo.
    </va-notification>

    <va-notification color="danger" v-if="refWSUpdate" class="refNoData">
      El servicio que ejecuta la actualización no se encuentra activo.
    </va-notification>
    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchProgram
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification
      color="danger"
      id="refNoData"
      class="refNoData noShow"
    >
      No se encontró información del periodo solicitado.
    </va-notification>
    <div class="tableCard">
      <DataTablePrograms
        :InfoView="DLPrograms"
        :HeadTable="HDProgram"
        :method="processData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchProgram from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormupdatePeriods from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTablePrograms from '@/components/data-tables/DataPeriod.vue'

export default {
  name: 'DataUpdate',
  components: {
    DataTablePrograms,
    FormSearchProgram,
    FormupdatePeriods,
  },
  data () {
    return {

      DegreeList: IberoHelpers.getDegrees(this.$store),
      formSchModel: {},
      formSearch: [
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar Periodo',
          class: 'col-md-3',
        },
        {
          id: 'Sch_ButtonNew',
          type: 'button',
          placeholder: 'Crear Periodo',
          class: 'col-md-3',
        },
      ],
      formUpdModel: {
        idPeriod: '',
        desPeriod: '',
        typeIncome: '',
        staActive: '',
        datStartDate: '',
        datEndDate: '',
        dat_StrartInscription: '',
        dat_EndInscription: '',
      },

      formUpdate: [
        {
          id: 'desPeriod',
          model: 'desPeriod',
          name: 'Periodo',
          type: 'input',
          placeholder: 'Periodo',
          values: '',
          validate: {
            required: true,
            regex: '^([a-zA-z]?)',
            max: 6,
          },
          class: 'col-md-4',
        },
        {
          id: 'typeIncome',
          model: 'typeIncome',
          name: 'Tipo de Ingreso',
          type: 'Select',
          placeholder: 'Selecciona un Tipo de Ingreso',
          class: 'col-md-4',
          values: [
            { id: 'Primer Ingreso', value: 'Primer Ingreso' },
            { id: 'Homologante', value: 'Homologante' },
          ],
          validate: {
            required: true,
          },
        },
        {
          id: 'staActive',
          model: 'staActive',
          name: 'Estado',
          type: 'Select',
          placeholder: 'Seleccionar...',
          class: 'col-md-4',
          values: [
            { id: 1, value: 'Activo' },
            { id: 0, value: 'Inactivo' },
          ],
          validate: {
            required: true,
          },
        },

        {
          id: 'datStartDate',
          model: 'datStartDate',
          name: 'Inicio Periodo',
          type: 'datepicker',
          placeholder: 'Periodo',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },

        {
          id: 'datEndDate',
          model: 'datEndDate',
          name: 'Fin Periodo',
          type: 'datepicker',
          placeholder: 'Periodo',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },

        {
          id: 'dat_StrartInscription',
          model: 'dat_StrartInscription',
          name: 'Inicio Insc.',
          type: 'datepicker',
          placeholder: 'inicio insc',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },

        {
          id: 'dat_EndInscription',
          model: 'dat_EndInscription',
          name: 'Fin Insc.',
          type: 'datepicker',
          placeholder: 'fin insc',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },
      ],

      HDProgram: [

        {
          name: 'desPeriod',
          title: 'Periodo',
          sortField: 'desPeriod',
          width: '20%',
        },
        {
          name: 'typeIncome',
          title: 'Tipo de Ingreso',
          sortField: 'typeIncome',
          width: '70%',
        },
        {
          name: 'datStartDate',
          title: 'inicio Periodo',
          sortField: 'datStartDate',
          width: '70%',
        },
        {
          name: 'datEndDate',
          title: 'fin Periodo',
          sortField: 'datEndDate',
          width: '70%',
        },
        {
          name: 'dat_StrartInscription',
          title: 'inicio inscripción',
          sortField: 'dat_StrartInscription',
          width: '70%',
        },
        {
          name: 'dat_EndInscription',
          title: 'fin inscripción',
          sortField: 'dat_EndInscription',
          width: '70%',
        },
        {
          name: '__slot:staActive',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      DLPrograms: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      isNew: false,
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'btn_Sch_Button':
          debugger
          this.isNew = false
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
        case 'btn_Sch_ButtonNew':
          this.limpiaref()
          this.clearFields()
          this.isNew = true
          IberoHelpers.forceRerender2(this)
          this.$modal.show('ProgramModal')
      }
      this.$refs.obsFieldsSearch.validate()
    },
    searchForm () {
      debugger
      document.getElementById('refNoData').classList.add('noShow')

      this.isNew = false
      let loader = this.$loading.show()
      var ListPeriods = IberoHelpers.getPeriod(this.$store, this.formSchModel, 0)
      this.renderComponent1 = false
      ListPeriods.then(Response => {
        if ((Response.data === undefined) || (Response.data === '')) {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLPrograms = Response.data
          } else {
            this.DLPrograms = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },
    updatePeriod () {
      debugger
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            var totalinf = IberoHelpers.updatePeriod(this.$store, this.formUpdModel)
            totalinf.then(Response => {
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.UpdRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')
              this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },
    AddProgram () {
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            debugger
            var totalinf = IberoHelpers.addPeriod(this.$store, this.formUpdModel)
            debugger
            totalinf.then(Response => {
              debugger
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.addRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')
              this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },
    CancelUser () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('ProgramModal')
    },

    limpiaref () {
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      document.getElementById('refNoData').classList.add('noShow')
    },
    clearFields () {
      this.formUpdModel.desPeriod = ''
      this.formUpdModel.staActive = ''
      this.formUpdModel.datStartDate = ''
      this.formUpdModel.datEndDate = ''
      this.formUpdModel.dat_StrartInscription = ''
      this.formUpdModel.dat_EndInscription = ''
    },
    processData: function (dataInf, refdata) {
      this.limpiaref()
      this.isNew = false
      this.formUpdModel.idPeriod = dataInf.idPeriod
      this.formUpdModel.desPeriod = dataInf.desPeriod
      this.formUpdModel.typeIncome = dataInf.typeIncome
      if (dataInf.staActive === true) { this.formUpdModel.staActive = 1 } else { this.formUpdModel.staActive = 0 }
      this.formUpdModel.datStartDate = dataInf.datStartDate
      this.formUpdModel.datEndDate = dataInf.datEndDate
      this.formUpdModel.dat_StrartInscription = dataInf.dat_StrartInscription
      this.formUpdModel.dat_EndInscription = dataInf.dat_EndInscription
      IberoHelpers.forceRerender2(this)
      this.$modal.show('ProgramModal')
    },
  },
}
</script>